export default "__VITE_ASSET__2eL_lhod__";